import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/expansions` is retired in favour of the per-game backlog at
 * `/catalogue/games/$gameSlug`. All known inbound links carried a
 * `?gameSlug=X` filter, so we redirect:
 *  - `?gameSlug=X` present → `/catalogue/games/$gameSlug`
 *  - no filter → `/games` (the coverage dashboard; admin picks a game)
 *
 * `/expansions/$id` (detail) and `/expansions/$id/manage` (edit) are
 * unaffected; they sit under the same layout (`route.tsx` → `<Outlet />`).
 */
export const Route = createFileRoute("/expansions/")({
	validateSearch: (search: Record<string, unknown>) => ({
		gameSlug: typeof search.gameSlug === "string" ? search.gameSlug : undefined,
	}),
	beforeLoad: ({ search }) => {
		if (search.gameSlug) {
			throw redirect({
				to: "/catalogue/games/$gameSlug",
				params: { gameSlug: search.gameSlug },
			})
		}
		throw redirect({ to: "/games" })
	},
})
